import { BehaviorSubject } from 'rxjs';
import { DestroyRef, inject, Injectable, EventEmitter } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { LikertQuestionParams, LikertQuestionViewModel } from './likert.model';
import { FormUpdate } from '../question.model';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable()
export class LikertPresenter {
  private readonly destroyRef: DestroyRef = inject(DestroyRef);
  load(
    vm: BehaviorSubject<LikertQuestionViewModel | null>,
    params: LikertQuestionParams,
    formChange: EventEmitter<FormUpdate>
  ) {
    const form = this.getForm(params);
    this.subscribeToFormChanges(form, formChange, params);

    // todo - for now we will only be able to correctly display the number
    //  of steps in likert controls (for MANUALLY configured Relay tabs) in Pathway ONCE a user has submitted data
    const maxValue = (params.value as any)?.max ? (params.value as any)?.max : params.steps ?? 5;
    vm.next({
      ...params,
      minValue: 1,
      maxValue: maxValue,
      form
    });
  }

  private getForm(params: LikertQuestionParams): FormGroup {
    const { key, value, required } = params;
    return new FormGroup({
      [key]: new FormControl(value, required ? [Validators.required] : [])
    });
  }

  private subscribeToFormChanges(form: FormGroup, formChange: EventEmitter<FormUpdate>, params: LikertQuestionParams) {
    form.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(value => {
      formChange?.emit({ key: params.key, value: value[params.key] });
    });
  }
}
